<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AMS">
<div class="image1"><img alt="images/himg-6-1.jpg" src="images/himg-6-1.jpg"/></div>
<p class="noind" id="pz15-3"><b><span class="dcap">T</span></b>he first verses of Matthew 5 list the Beatitudes, which were blessings spoken by Jesus for His followers. In verse eight, Jesus said, “Blessed are the pure in heart, for they shall see God.” So can flawed, imperfect people ever be pure in heart? Yes they can, but they will only be pure in heart if God purifies their hearts—and, thankfully, God can do that. </p>
<p id="pz15-4">Your heart is purified when you put your faith in the truth that Jesus is God’s Son, when you believe the blood He shed on the cross paid the price for your sins, and when you believe that He rose from the dead, victorious over sin and death. This does not mean you will never sin again while on earth, so how do you keep your heart pure? Again, you can’t on your own, but God can when you ask: “Create in me a clean heart, O God” (Psalm 51:10). Purified by God, you see God, just as Jesus promised. You have access to your holy Father, and you can fellowship with Him through the privilege of prayer. Furthermore, you will one day see God face-to-face in heaven. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter10.vue?cba61dfc